export default "__VITE_ASSET__ebbfc574__"